// Orange "Not synced" chip for offline-created/edited rows still in the outbox.
import React from "react";
import { Badge } from "framework7-react";

const PendingSyncBadge = ({ item }) => {
  if (!item?._pendingSync) return null;
  return (
    <Badge slot="after" color="orange">
      Not synced
    </Badge>
  );
};

export default PendingSyncBadge;
